<template>
  <div class="w-full max-w-xs">
    <form class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
      <div class="mb-4">
        Team hinzufügen
      </div>
      <div class="mb-4">
        <label
          class="block text-gray-700 text-sm font-bold mb-2"
          for="username"
        >
          Spieler
        </label>
        <div
          id="username"
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          type="text"
        >
          {{ users.length }} Spieler gewählt.
        </div>
      </div>
      <div class="w-full px-3 mb-6 md:mb-0">
        <label
          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          for="grid-state"
        >
          Team
        </label>
        <div class="relative w-full">
          <select
            id="grid-state"
            v-model="selectedTeam"
            class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
          >
            <option
              v-for="team in teams"
              :key="team.teamId"
              :value="team.teamId"
            >
              {{ team.name }}
            </option>
          </select>
          <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
            <svg
              class="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
      </div>
      <div class="flex items-center justify-between mt-5">
        <button
          class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          type="button"
          @click="assignPlayers(selectedTeam,users)"
        >
          Team Zuweisen
        </button>
        <div
          class="inline-block align-baseline font-bold text-sm text-blue-500 hover:text-blue-800"
          @click="cancel()"
        >
          Abbrechen
        </div>
      </div>
    </form>
    <p class="text-center text-gray-500 text-xs">
      &copy;2020 Acme Corp. All rights reserved.
    </p>
  </div>
</template>

<script>
import apiService from '../api/apiService'

export default {
    name: 'TeamsAddToUsers',

    data () {
        return {
            users: [],
            teams: [],
            selectedTeam: null
        }
    },
    async mounted () {
        this.users = this.$route.params.users
        this.teams = (await apiService.getMyTeams()).data
    },
    methods: {
        async assignPlayers (team, user) {
            if (this.selectedTeam) {
                await this.users.forEach(function (user) {
                    return apiService.assignTeamToPlayer(user, team)
                })

                this.$router.back()
            }
        },

        cancel () {
            this.$router.back()
        }
    }
}
</script>

<style scoped>

</style>